import { render, staticRenderFns } from "./ModalCreateTransferMaterials.vue?vue&type=template&id=a132ce28"
import script from "./ModalCreateTransferMaterials.vue?vue&type=script&lang=js"
export * from "./ModalCreateTransferMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports